/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AlimtalkActionRequestDto = {
  tokenHash: string;
  action: AlimtalkActionRequestDto.action;
};

export namespace AlimtalkActionRequestDto {
  export enum action {
    AVAILABLE = 'available',
    NO_SHOW = 'no-show',
    LATE = 'late',
    UNAVAILABLE = 'unavailable',
    CONTRACT = 'contract',
    NOTICE_CONFIRM = 'notice-confirm',
  }
}
